export default __webpack_public_path__ + "static/media/nike_stimuli_es.3590ba01.mp4";